import { Grid } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SavePaymentMethodProveedor } from '../../shared/components';

export type CreatePaymentMethodProveedorPageProps = {};

const CreatePaymentMethodProveedorPage: React.FC<CreatePaymentMethodProveedorPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_formapagoproveedor);

  return (
    <Grid container spacing={2} padding="24px">
      <SavePaymentMethodProveedor titlePage="Crear Método de Pago Proveedor" />
    </Grid>
  );
};

export default CreatePaymentMethodProveedorPage;
